export const DETAILS_FETCH_REQUEST='details-fetch-request';
export const DETAILS_FETCH_SUCCESS='details-fetch-success';
export const DETAILS_FETCH_FAILURE='details-fetch-failure';